

<template>
    <v-container class="" fluid>
        <v-row no-gutters class="">
            <AddPayment :addPaymentShow="showPayment" @closeAddPayment="showPayment = false" />
            <div class=" !w-full !px-5 bg-black h-[calc(100vh-150px)] overflow-hidden  rounded-2xl">
                <div class="">
                    <v-card-title class="justify-center py-6 text-center">
                        <h4 :class="`${routeLink}_fortext !text-2xl font-Handel `">
                            Payment Details
                        </h4>
                    </v-card-title>
                </div>
                <div class="flex flex-col items-center">
                    <PaymentCreditCard  v-motion-pop />
                    <v-btn :color="colorAsRoute" outlined class="my-4" @click.prevent="showPayment = true">{{ !userDataPaymentMethod ? 'Add Payment' : 'Update Card' }}</v-btn>
                </div>
                <div class="h-[calc(100vh-440px)] overflow-hidden">
                    <h3 :class="`${routeLink}_fortext !text-2xl font-Handel text-center my-2`">Transactions History</h3>
                    <TransactionList />
                </div>
            </div>
        </v-row>
    </v-container>
</template>

<script>
import AddPayment from './AddPayment.vue';
import PaymentCreditCard from './PaymentCreditCard.vue';
import TransactionList from './TransactionList.vue';
import TransactionReceipt from './TransactionReceipt.vue';


export default {
    components: { PaymentCreditCard, TransactionList, TransactionReceipt, AddPayment },
    data() {
        return {
            showPayment: false,
        }
    },
    computed: {
        userDataPaymentMethod() {
            return this.$store.getters.StateUser.data.pm_cardholder_name;
        },
        colorAsRoute() {
            if (this.routeLink == 'straight') {
                return '#a07a1d'
            }
            else if (this.routeLink == 'gay') {
                return '#88c3fa'
            }
            else if (this.routeLink == 'lesbian') {
                return '#9e2eec'
            }
        },
    },
}
</script>

<style scoped>
.balss {
    background-image: url(@/assets/images/fire-wallpaper-1080x1920-30.jpg);
    background-position: center;
    background-size: cover;
}
</style>